export const environment = {
  production: false,
  env_file: "dev",

  config:{
    apiUrlItek:'https://api-itek.dev.itek.dental',
    apiUrlCheckout:'https://api-checkout.dev.itek.dental',
    hasuraWss: 'wss://hasura.dev.itek.dental:8070/v1/graphql',
  },
  token:{
    apiItek:'UzNuaGFTdXAzclVsdHI0TWFzdDNyQKsY93QzclBsdSRhZHZhbmMzZA==',
    apiCheckout:'UzNuaGFTdXAzclVsdHI0TWFzdDNyQKsY93QzclBsdSRhZHZhbmMzZA==',
  },
  jwt: {
    iss: 'iTek',
    sub: 'itek@itek.dental',
    aud: 'itek.dental'
  }
};

